import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Locked from './icon-lock.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Locked {...validProps} />;
}
SvgComponent.iconName = 'locked';

/**
 * @deprecated This is a legacy icon
 */
export const LockedIcon = svgIconWrapper(SvgComponent);
